import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotEventsWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.ottopilotEvents> & {
    /** Owned dynamic UDO templates keyed by Event template ID. Columns live on the UDO template. */
    eventUdoTemplates: Record<Uuid, {
        udoTemplateId: Uuid;
    }>;
};

export const ottopilotEventsWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({}),
    eventUdoTemplates: zod.record(uuidZodValidator, zod.strictObject({
        udoTemplateId: uuidZodValidator,
    })),
}) satisfies zod.ZodType<OttopilotEventsWorkspaceCapabilityUdoBindings>;
